import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="56" height="56" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M46.03 47.71c-1.063-2.977-3.406-5.607-6.666-7.484-3.26-1.876-7.255-2.893-11.364-2.893-4.11 0-8.104 1.017-11.363 2.893-3.26 1.877-5.604 4.507-6.668 7.484" stroke="#000" strokeLinecap="round" /><circle cx="28" cy="18.667" stroke="#000" strokeLinecap="round" r="9.333" /></svg>;